import { useState, Fragment } from 'react';
import { useTranslation } from 'react-i18next';
import { NavLink } from 'react-router-dom';
import { Box, Avatar, Menu, ListItemButton, Typography, Divider, ListItemIcon } from '@mui/material';
import { Person as PersonIcon, Logout as LogoutIcon, ExpandMore as ExpandMoreIcon } from '@mui/icons-material';
import { useTheme } from '@mui/material/styles';
import { useAuth } from '@contexts/AuthContext';

export default function AccountMenu({ sx, ...props }) {
    const { t } = useTranslation();
    const { user, doLogout } = useAuth();
    const [anchorEl, setAnchorEl] = useState(null);
    const theme = useTheme();
    const open = Boolean(anchorEl);

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleMyAccount = () => {
        setAnchorEl(null);
    };

    return (
        <Fragment>
            <Box
                onClick={handleClick}
                sx={{
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'center',
                    cursor: 'pointer',
                    ...sx
                }}
                aria-controls={open ? 'account-menu' : undefined}
                aria-haspopup="true"
                aria-expanded={open ? 'true' : undefined}
                {...props}
            >
                <Avatar sx={{
                    bgcolor: theme.palette.primary.main,
                    width: {xs: 40, sm: 32},
                    height: {xs: 40, sm: 32},
                    mr: 1,
                    fontSize: {xs: 22, sm: 16}
                }}>{user ? user.user_initials : ''}</Avatar>
                <Box sx={{ display: { xs: 'none', md: 'flex' } }}>
                    {user ? user.user_full_name : ''}
                    <ExpandMoreIcon />
                </Box>
            </Box>
            <Menu
                anchorEl={anchorEl}
                id="account-menu"
                open={open}
                onClose={handleMyAccount}
                onClick={handleMyAccount}
                slotProps={{
                    paper: {
                        elevation: 0,
                        sx: {
                            overflow: 'visible',
                            filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
                            mt: 1.5,
                            '& .MuiAvatar-root': {
                                width: 32,
                                height: 32,
                                ml: -0.5,
                                mr: 1,
                            },
                            '&::before': {
                                content: '""',
                                display: 'block',
                                position: 'absolute',
                                top: 0,
                                right: 14,
                                width: 10,
                                height: 10,
                                bgcolor: 'background.paper',
                                transform: 'translateY(-50%) rotate(45deg)',
                                zIndex: 0,
                            },
                        },
                    }
                }}
                transformOrigin={{ horizontal: 'right', vertical: 'top' }}
                anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
            >
                <Box sx={{ display: { xs: 'block', md: 'none' }, px: 2, py: 1 }}>
                    <Typography variant="h2" component="div" sx={{ flexGrow: 1 }}>
                        {user ? user.user_full_name : ''}
                    </Typography>
                    <Divider />
                </Box>

                <NavLink to="/account" style={{ textDecoration: 'none', color: 'inherit' }}>
                    <ListItemButton>
                        <ListItemIcon>
                            <PersonIcon />
                        </ListItemIcon>
                        {t('My account')}
                    </ListItemButton>
                </NavLink>

                <ListItemButton onClick={doLogout}>
                    <ListItemIcon>
                        <LogoutIcon />
                    </ListItemIcon>
                    {t('Logout')}
                </ListItemButton>

            </Menu>
        </Fragment>
    );
}